import api from "../api";

export const createCheckoutSession = (data) => {
  return api.getApi().post(api.getBaseUrl() + "create-checkout-session", data);
};
export const getUser = (id) => {
  return api.getApi().get(api.getBaseUrl() + "users/" + id);
};
